import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/acbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-categories",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-safety",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-pricing",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-beginners",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-suppliers",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-trends",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-tips",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-seasonal",
    element: <ArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-reseller",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;